import React, { useEffect, useRef } from 'react'
import styles from "../css/Sort.module.css"
import { FiCalendar, FiEdit2, FiType } from 'react-icons/fi';
import { LuCalendarPlus } from "react-icons/lu";
import { MdOutlineEditCalendar } from "react-icons/md";

export const attrDict = {
    title: 'Title',
    createdAt : 'Date Created',
    updatedAt: 'Date Modified',
}

export const sortIcons = {
    title: <FiType />,
    createdAt: <LuCalendarPlus/>,
    updatedAt: <MdOutlineEditCalendar/>
}
const SortMenu = ({sortParams,onChangeSortParams,closeMenu}) => {
    const menu = useRef(null)

    useEffect(()=>{
        const handleClick = (e) => {
            if (!menu.current?.parentNode?.contains(e.target)){
                closeMenu()
            }
        }
        window.addEventListener("mousedown",handleClick)

        return () => {
            window.removeEventListener("mousedown",handleClick)
        }
    },[closeMenu])

    const select = (field,order) => {
        onChangeSortParams({field:field,order:order})
        closeMenu()
    }


  return (
    <div data-testid = "sort-menu" className={styles.dropdown} ref = {menu}>
        <div className={styles.header}>Sort by</div>
        <div className = {styles.body}>
            <div className={styles.group}>Title</div>
            <div data-testid = "sort-title-asc" className = {`${styles.item} ${(sortParams.field === "title" && sortParams.order === "asc") ? styles.selected : ""}`} onClick = {()=>select("title","asc")}>
                <div className ={styles.itemLeft}>
                    <div className={styles.itemIcon}><FiType /></div>
                    <div className={styles.itemLabel}>Title</div>
                </div>
                <div className={styles.itemDir}>A → Z</div>
            </div>
            <div data-testid = "sort-title-desc" className = {`${styles.item} ${(sortParams.field === "title" && sortParams.order === "desc") ? styles.selected : ""}`} onClick = {()=>select("title","desc")}>
                <div className={styles.itemLeft}>
                    <div className={styles.itemIcon}><FiType /></div>
                    <div className={styles.itemLabel}>Title</div>
                </div>
                <div className={styles.itemDir}>Z → A</div>
            </div>

            <div className={styles.group}>Date Created</div>
            <div data-testid = "sort-createdAt-desc" className = {`${styles.item} ${(sortParams.field === "createdAt" && sortParams.order === "desc") ? styles.selected : ""}`} onClick = {()=>select("createdAt","desc")}>
                <div className={styles.itemLeft}>
                    <div className={styles.itemIcon}><FiCalendar /></div>
                    <div className={styles.itemLabel}>Date Created</div>
                </div>
                <div className={styles.itemDir}>Newest first</div>
            </div>
            <div data-testid = "sort-createdAt-asc" className = {`${styles.item} ${(sortParams.field === "createdAt" && sortParams.order === "asc") ? styles.selected : ""}`} onClick = {()=>select("createdAt","asc")}>
                <div className={styles.itemLeft}>
                    <div className={styles.itemIcon}><FiCalendar /></div>
                    <div className={styles.itemLabel}>Date Created</div>
                </div>
                <div className={styles.itemDir}>Oldest first</div>
            </div>

            <div className={styles.group}>Date Modified</div>
            <div data-testid = "sort-updatedAt-desc" className={`${styles.item} ${(sortParams.field === "updatedAt" && sortParams.order === "desc") ? styles.selected : ""}`}  onClick = {()=>select("updatedAt","desc")}>
                <div className={styles.itemLeft}>
                    <div className={styles.itemIcon}><FiEdit2 /></div>
                    <div className={styles.itemLabel}>Date Modified</div>
                </div>
                <div className={styles.itemDir}>Newest first</div>
            </div>
            <div data-testid = "sort-updatedAt-asc" className = {`${styles.item} ${(sortParams.field === "updatedAt" && sortParams.order === "asc") ? styles.selected : ""}`} onClick = {()=>select("updatedAt","asc")}>
                <div className={styles.itemLeft}>
                    <div className={styles.itemIcon}><FiEdit2 /></div>
                    <div className={styles.itemLabel}>Date Modified</div>
                </div>
                <div className={styles.itemDir}>Oldest first</div>
            </div>
        </div>
    </div>
  )
}

export default SortMenu